<template>
  <div
    class="rose-svg"
    :style="`left: ${left}px; top: ${top}px`"
    :class="{ absolute }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 72 72"
      :width="`${size}px`"
      :height="`${size}px`"
      :transform="`matrix(1, 0, 0, 1, 0, 0)rotate(${angle})`"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g id="color">
          <path
            fill="#EA5A47"
            stroke="none"
            d="M38.1631,16.8246c0,0-5.1901-0.5135-5.8625,3.0442s1.757,6.4979,2.9313,6.6556 c0,0-2.5562,6.2939,1.8725,9.6935s9.1611,1.1911,10.9752-2.1216c0,0,8.0846,0.9665,8.4396-6.4577c0,0-0.9641-6.4239-5.8652-6.2931 c0,0,1.3634-6.9761-3.8985-8.4706S38.1631,16.8246,38.1631,16.8246z"
          ></path>
          <path
            fill="#B1CC33"
            stroke="none"
            d="M25.9293,32.6035c3.992,4.886,2.805,12.462,2.805,12.462s-7.66-0.347-11.653-5.233 s-2.805-12.462-2.805-12.462S21.9373,27.7215,25.9293,32.6035z"
          ></path>
          <path
            fill="#D22F27"
            stroke="none"
            d="M44.4122,38.2369c0.9095,1.9758,1.874,3.7171,3.4969,4.5633c1.7075,0.8903,3.6834,0.6758,5.1278-0.1255 c1.5266-0.8468,2.6551-2.5099,2.6972-4.5946c0.0355-1.7625-1.1056-3.5236-2.1483-5.4034l-5.0366,2.4325L44.4122,38.2369z"
          ></path>
          <path
            fill="#D22F27"
            stroke="none"
            d="M51.9515,20.0738c0,0,0.1963-3.2744-0.3034-4.0737c0,0,1.1424-1.6739,3.088-1.3169 c1.4815,0.2718,2.3317,3.3174,2.653,4.7549c0.1124,0.5031,0.2884,0.7228-0.0498,1.1118c-0.5455,0.6274-1.8031,1.8051-2.9605,2.0586 L51.9515,20.0738z"
          ></path>
          <path
            fill="#EA5A47"
            stroke="none"
            d="M48.3664,22.704c0,1.6312-2.0931,2.9535-4.6751,2.9535s-4.6751-1.3223-4.6751-2.9535"
          ></path>
          <path
            fill="#D22F27"
            stroke="none"
            d="M50.5245,31.1699c-0.5009,0.6863-1.4235,1.1037-2.2859,1.3551c-1.1433,0.3333-2.3619,0.4293-3.543,0.2537 c-2.1134-0.3143-4.0049-1.2693-5.4503-2.6508c-1.3591-1.2989-2.3237-2.9748-2.7075-4.8494c0,0-0.0062-0.0313-0.0135-0.0891 c-0.0513-0.4042-0.1594-2.1031,1.3907-3.4133c0.6559-0.5544,1.5837-0.882,2.4763-1.0041c1.1833-0.1618,2.4028-0.0781,3.5418,0.2685 c2.038,0.6203,3.7539,1.8412,4.9606,3.4181c1.1346,1.4827,1.819,3.2801,1.8975,5.1888"
          ></path>
          <path
            fill="#EA5A47"
            stroke="none"
            d="M39.0161,22.8385c-0.0018,1.6129,1.9173,2.6679,4.5145,2.7789s4.7591-1.1201,4.8288-2.7498l-0.0008-0.3155 c-0.0191-1.632-2.1412-2.9744-4.7397-2.9983C41.0203,19.5299,38.997,21.2065,39.0161,22.8385"
          ></path>
          <path
            fill="#D22F27"
            stroke="none"
            d="M43.174,24.8175c-0.6105-1.4165,0.3289-3.1838,2.0983-3.9475c0.9179-0.3962,1.9603-0.3538,2.8746-0.035 c1.4172,0.4941,2.4105,1.8808,2.3753,3.3822c-0.0051,0.2183-0.0355,0.4264-0.1035,0.6054"
          ></path>
          <path
            fill="#D22F27"
            stroke="none"
            d="M43.174,23.8299c-0.6105,1.4165,0.3289,3.1838,2.0983,3.9475c0.9179,0.3962,1.9603,0.3538,2.8746,0.035 c1.4172-0.4941,2.4105-1.8808,2.3753-3.3822c-0.0051-0.2183-0.0355-0.4264-0.1035-0.6054"
          ></path>
          <path
            fill="none"
            stroke="#b1cc33"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M22.51,31.1543"
          ></path>
          <path
            fill="none"
            stroke="#a57939"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M50.9336,27.4205"
          ></path>
          <path
            fill="none"
            stroke="#a57939"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M48.2713,29.0961"
          ></path>
        </g>
        <g id="hair"></g>
        <g id="skin"></g>
        <g id="skin-shadow"></g>
        <g id="line">
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M49.8675,30.3979c-0.4428,0.6348-1.2583,1.0208-2.0207,1.2533c-1.0107,0.3083-2.0878,0.3971-3.1319,0.2346 c-1.8682-0.2907-3.5402-1.174-4.8179-2.4517c-1.2014-1.2014-2.0541-2.7514-2.3933-4.4853"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M40.0032,22.8224c0-1.6312,1.6529-2.9535,3.6919-2.9535c2.039,0,3.6919,1.3223,3.6919,2.9535"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M49.4103,24.9866c0,1.1609-1.1763,2.1019-2.6274,2.1019c-0.7528,0-1.4609-0.3402-1.9982-0.8332 c-0.8327-0.7641-1.1063-2.0186-0.6344-3.0455c0.0686-0.1493,0.1516-0.284,0.252-0.3874"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M53.3083,15.9025c0.9791-0.6237,2.4048-0.1371,3.1844,1.0868c0.7796,1.2239,0.6178,2.7216-0.3613,3.3453"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M54.1952,35.9239c1.1689,2.1072,0.4082,4.7631-1.699,5.932c-2.1072,1.1689-4.7631,0.4082-5.932-1.699"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M38.1631,16.1932c-2.253-0.8548-5.9182,1.2312-6.5125,3.6757c-0.5693,2.3415,0.9006,6.2141,3.1536,7.0689"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M50.8669,20.8344c5.4159,0.6272,6.3961,6.4611,5.8024,8.7734c-0.8819,3.4349-5.3899,5.4013-8.1201,4.6907"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M50.8669,20.8344c1.2816-3.5081-0.5232-7.3909-4.0313-8.6725c-3.5081-1.2816-7.3909,0.5232-8.6725,4.0313"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M34.8042,26.9378c-2.0326,3.7956-0.6035,8.5203,3.1921,10.5529s8.5203,0.6035,10.5529-3.1921"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M25.9293,32.3094 c3.992,4.886,2.805,12.462,2.805,12.462s-7.66-0.347-11.653-5.233s-2.805-12.462-2.805-12.462S21.9373,27.4274,25.9293,32.3094z"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M37.1043,40.8644 c-3.438,3.548-7.676,10.246-5.829,20.735"
          ></path>
          <path
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
            d="M37.4663,24.7443"
          ></path>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'WomensDay',
  props: {
    left: {
      default: 0,
    },
    top: {
      default: 0,
    },
    angle: {
      default: 0,
    },
    size: {
      default: 30,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.rose-svg {
  position: relative;
  pointer-events: none;
}
.absolute {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  width: auto;
}
</style>
